<i18n>
{
	"en": {
		"parallelSuborder": "Create Parallel Suborder"
	},
	"no": {
		"parallelSuborder": "Lag parallell strekning"
	}
}
</i18n>
<template>
	<div>
		<svg :viewBox="viewBox" :style="containerStyle" class="sub-order-graph">
			<defs>
				<!-- <symbol id="order-fill" viewBox="0 0 32 32">
					<path d="M 16.000001,32 29.858268,24.062992 V 7.9370082 L 16.000001,-2e-7 2.1417325,7.9370082 V 24.062992 Z"/>
				</symbol>

				<symbol id="order-outline" viewBox="0 0 32 32">
					<path d="M 29.406193,7.6357009 16.582878,0.17486293 c -0.349727,-0.233151 -0.816029,-0.233151 -1.165756,0 L 9.005465,3.9052819 2.593807,7.6357009 C 2.24408,7.8688529 2.010929,8.2185789 2.010929,8.568306 v 14.805099 c 0,0.466303 0.233151,0.816029 0.582878,1.049181 l 12.823315,7.460838 C 15.650273,32 15.766849,32 16,32 c 0.233151,0 0.349727,0 0.582878,-0.116576 l 12.823315,-7.460838 c 0.349727,-0.233152 0.582878,-0.582878 0.582878,-1.049181 V 8.5683059 c 0,-0.349727 -0.233151,-0.699453 -0.582878,-0.932605 z M 9.588342,6.2367939 20.080146,12.298725 16,14.630237 5.508197,8.5683059 Z M 16,2.6229499 26.491803,8.6848819 22.411658,11.016393 11.919854,4.9544619 Z M 4.342441,10.666667 14.834244,16.728597 V 28.852458 L 4.342441,22.790527 Z M 17.165756,28.852458 V 16.728597 l 4.080146,-2.331511 v 2.214936 c 0,0.699453 0.466302,1.165756 1.165756,1.165756 0.699453,0 1.165756,-0.466303 1.165756,-1.165756 v -3.613843 l 4.080145,-2.331512 v 12.12386 z" />
				</symbol>

				<symbol id="truck-fill" viewBox="0 0 48 32">
					<path
						class="st2"
						d="M15,4v4H9v8l-8,3h0v7h4.1c0.4-1.7,2-3,3.9-3s3.4,1.3,3.9,3H15h10.1c0.4-1.7,2-3,3.9-3s3.4,1.3,3.9,3h2.3
						c0.4-1.7,2-3,3.9-3s3.4,1.3,3.9,3H47v-6V4H15z"
					/>
				</symbol>
				<symbol id="truck-outline" viewBox="0 0 48 32">
					<path
						class="st3"
						d="M47,3H15c-0.6,0-1,0.4-1,1v3H9H5C4.6,7,4.3,7.2,4.1,7.6l-4,8C0,15.7,0,15.8,0,16v3v7c0,0.6,0.4,1,1,1h4.1
						c0,0,0,0,0,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3H15h10.1c0,0,0,0,0,0c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3h2.3c0,0,0,0,0,0
						c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3H47c0.6,0,1-0.4,1-1v-6V4C48,3.4,47.6,3,47,3z M16,5h30v14H16V8V5z M5.6,9H8v6.3l-6,2.2v-1.3L5.6,9
						z M9,28c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c0,0,0,0,0,0c0,0,0,0,0,0c1.1,0,2,0.9,2,2C11,27.1,10.1,28,9,28z M9.5,22
						c-0.2,0-0.4,0-0.5,0c-0.2,0-0.4,0-0.5,0c-1.8,0.2-3.3,1.3-4,3H2v-5.3l7.4-2.8C9.7,16.8,10,16.4,10,16V9h4v11v5h-0.4
						C12.9,23.4,11.3,22.2,9.5,22z M29,28c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c0,0,0,0,0,0c0,0,0,0,0,0c1.1,0,2,0.9,2,2
						C31,27.1,30.1,28,29,28z M39,28c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c0,0,0,0,0,0c0,0,0,0,0,0c1.1,0,2,0.9,2,2C41,27.1,40.1,28,39,28z
						M46,25h-2.4c-0.7-1.6-2.3-2.8-4-3c-0.2,0-0.4,0-0.5,0c-0.2,0-0.4,0-0.5,0c-1.8,0.2-3.3,1.3-4,3h-0.8c-0.7-1.6-2.3-2.8-4-3
						c-0.2,0-0.4,0-0.5,0c-0.2,0-0.4,0-0.5,0c-1.8,0.2-3.3,1.3-4,3H16v-4h30V25z"
					/>
				</symbol> -->

				<radialGradient id="myGradient">
					<stop offset="40%" stop-color="#999"/>
					<stop offset="100%" stop-color="transparent"/>
				</radialGradient>
			</defs>
			<g id="guidelines">
				<path
					v-for="(circle,i) in circles"
					:key="i"
					:d="`M ${circle.x},${circle.y} L ${viewBoxWidth - 40},${circle.y}`"
					stroke-width="1"
					stroke="#aaaaaa"
				/>
			</g>
			<g id="paths">
				<g
					v-for="(line,i) in lines"
					:key="i"
					class="graph-path"
					:data-id="line.subOrder.id"
				>
					<path
						fill="none"
						:stroke-width="nodeRadius*0.25"
						stroke="#1070ca"
						:d="line.d"
						class="graph-path-display"
					/>
					<path
						fill="none"
						:stroke-width="nodeRadius"
						stroke="transparent"
						:d="line.d"
						@mouseenter="onPathEnter(line)"
						@mouseleave="onPathLeave()"
						@click="$emit('selected',i)"
					/>
				</g>
			</g>
			<g id="highlights" style="pointer-events: none">
				<template v-for="(line,i) in lines">
					<path
						v-if="activeId === line.subOrder.id || (selectedSubOrder && selectedSubOrder.id) === line.subOrder.id"
						:key="`${i}-outer`"
						fill="none"
						stroke="#084b8a"
						:stroke-width="nodeRadius*0.65"
						:d="line.d"
					/>
				</template>
				<template v-for="(line,i) in lines">
					<path
						v-if="activeId === line.subOrder.id || (selectedSubOrder && selectedSubOrder.id) === line.subOrder.id"
						:key="`${i}-inner`"
						fill="none"
						stroke="#1070ca"
						:stroke-width="nodeRadius*0.25"
						:d="line.d"
					/>
				</template>
			</g>
			<g id="circles">
				<g
					v-for="(circle,i) in circles"
					:key="i"
					@contextmenu="_onContextMenu($event, circle.subOrder.id)"
				>
					<circle
						:r="circle.r*1.1"
						:cx="circle.x"
						:cy="circle.y"
						fill="url(#myGradient)"
						transform="translate(0,2)"
					/>
					<circle
						:r="circle.r"
						:cx="circle.x"
						:cy="circle.y"
						:title="circle.title"
						fill="white"
					/>
					<use
						:x="circle.x-halfIconSize"
						:y="circle.y-halfIconSize"
						:width="halfIconSize*2"
						:height="halfIconSize*2"
						fill="#ddebf7"
						xlink:href="#order-fill"
					/>
					<use
						:x="circle.x-halfIconSize"
						:y="circle.y-halfIconSize"
						:width="halfIconSize*2"
						:height="halfIconSize*2"
						fill="#1070ca"
						xlink:href="#order-outline"
					/>
				</g>
			</g>
			<g>
				<foreignObject
					v-for="(circle,i) in circles"
					:key="i"
					:x="viewBoxWidth - 210"
					:y="circle.y - 9"
					width="180"
					:height="yScale"
				>
					<div style="margin: 0 auto; text-align: right; font-size: 1em">
						<div
							class="graph-label"
							@contextmenu="_onContextMenu($event, circle.subOrder.id)"
						>
							{{ circle.title }}
						</div>
					</div>
				</foreignObject>

			</g>
		</svg>


		<t-popover
			ref="contextMenu"
			closeOnClick
			closeOnRightClick
			@open="contextMenuOpen = true"
			@close="contextMenuOpen = false;"
		>
			<t-menu>
				<t-menu-group>
					<t-menu-item icon="plus" @click="$emit('createParallelSuborder',subOrderId)"><strong>{{$t('parallelSuborder')}}</strong></t-menu-item>
				</t-menu-group>
			</t-menu>
		</t-popover>
	</div>
</template>

<script>
import processSubOrders from './subOrderGraph/processSubOrders';
import calculateLine from './subOrderGraph/calculateLine';
import {
	mapState
} from '../store/newOrder.store.js';

export default {
	props: {
		width: {
			type: [ String, Number ],
			default: '100%'
		},
		height: {
			type: [ String, Number ],
			default: 'auto'
		},
		xScale: {
			type: Number,
			default: 40
		},
		yScale: {
			type: Number,
			default: 80
		},
		nodeRadius: {
			type: Number,
			default: 16
		},
		nodeStrokeWidth: {
			type: Number,
			default: 4
		}
	},
	data() {
		return {
			activeId: undefined,
			contextMenuOpen: false,
			subOrderId: null
		};
	},
	computed: {
		...mapState(['subOrders', 'selectedSubOrder']),

		nodesAndLines() {
			return processSubOrders(this.subOrders);
		},
		circles() {
			let result = [];
			let { nodes } = this.nodesAndLines;
			for (let node of nodes) {
				result.push({
					x: node.x*this.xScale,
					y: node.y*this.yScale,
					r: this.nodeRadius,
					// title: `${node.fromParty.postalPlace} - ${node.toParty.postalPlace}`,
					title: node.party.name,
					subOrder: node.subOrder,
				});
			}
			// console.log(result);
			return result;
		},
		lines() {
			let { lines } = this.nodesAndLines;
			// console.log(lines)
			return calculateLine(lines, this.xScale, this.yScale, this.nodeRadius);
		},
		extents() {
			let minX = Number.MAX_VALUE;
			let minY = Number.MAX_VALUE;
			let maxX = Number.MIN_VALUE;
			let maxY = Number.MIN_VALUE;
			for (let circle of this.circles) {
				if (minX > circle.x - circle.r)
					minX = circle.x - circle.r;
				if (minY > circle.y - circle.r)
					minY = circle.y - circle.r;
				if (maxX < circle.x + circle.r)
					maxX = circle.x + circle.r;
				if (maxY < circle.y + circle.r)
					maxY = circle.y + circle.r;
			}
			return [ minX-10, minY-10, maxX+10, maxY+10 ];
		},
		viewBoxWidth() {
			return this.extents[2] - this.extents[0] + 210;
		},
		viewBox() {
			return `${this.extents[0]} ${this.extents[1]} ${this.viewBoxWidth} ${this.extents[3] - this.extents[1]}`;
		},
		paddedNodeRadius() {
			return this.nodeRadius*0.9;
		},
		halfIconSize() {
			return this.nodeRadius*0.7;
		},
		containerStyle() {
			return {
				width: this.width,
				height: this.height
			};
		}
	},
	methods: {
		onPathEnter(line) {
			this.activeId = line.subOrder.id;
		},
		onPathLeave() {
			this.activeId = undefined;
		},
		_onContextMenu(event, id) {
			console.log(id);
			this.subOrderId = id;
			let popover = this.$refs.contextMenu;
			if (popover) {
				popover.open({ top: event.clientY, left: event.clientX });
				event.preventDefault();
			}
		},
		clicky(e) {
			console.log(e);
		}
	}
};
</script>

<style lang="scss" scoped>
.sub-order-graph {
	box-sizing: border-box;
	background-color:#f4f6f7;
	padding: 5px;
	width: 100%;
}
.graph-pathmhover {
	z-index: 4;
}

.graph-pathmhover > .graph-path-display{
	stroke: darken(cornflowerblue, 10%);
}

.graph-path-highlight {
	display: none;
}

.graph-label {
	background-color: #1070ca;
	color: white;
	border-radius: 4px;
	padding: 0px 3px;
	display: inline-block;
	overflow-x: hidden;
	text-overflow: ellipsis;
	text-align: left;
	white-space: nowrap;
	max-width: 100%;
}
</style>